(ns frontend.view.reports.custom.view
  (:require
   [frontend.view.reports.custom.alj :as alj]
   [frontend.view.reports.custom.panostaja :as panostaja]
   [frontend.view.reports.custom.knight :as knight]
   [frontend.view.reports.custom.knight-2 :as knight-2]
   [frontend.view.reports.custom.capman-buyout.view :as capman-buyout]
   [frontend.view.reports.custom.diamond-edge-ventures-tables :as diamond-edge-ventures-tables]
   [frontend.tenant-customizations :as tenant-customizations]))

(defn custom-view
  [args]
  [:div.py-3
   (when (tenant-customizations/panostaja?)
     [panostaja/view args])

   (when (tenant-customizations/knight-therapeutics?)
     [knight/view args])

   (when (tenant-customizations/knight-therapeutics?)
     [knight-2/view args])

   (when (tenant-customizations/alj?)
     [alj/view args])

   (when (tenant-customizations/capman?)
     [capman-buyout/view args])

   (when (tenant-customizations/diamond-edge-ventures?)
     [diamond-edge-ventures-tables/view args])])
